"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuList = exports.SubMenuItemInner = exports.SubMenuItem = exports.ITEM_PADDING = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
const {
  colours,
  borderRadius
} = _uiKit.theme;
const ITEM_PADDING = exports.ITEM_PADDING = (0, _styledComponents.css)(["padding:12px 16px 12px 16px;"]);
const SubMenuList = exports.SubMenuList = _styledComponents.default.ul.withConfig({
  displayName: "SubMenustyle__SubMenuList",
  componentId: "sc-xjrtor-0"
})(["list-style:none;outline:none !important;padding-left:0;", ";div{user-select:text;}"], props => props.hasMultiColumns ? 'display: flex' : '');
const SubMenuItem = exports.SubMenuItem = _styledComponents.default.li.withConfig({
  displayName: "SubMenustyle__SubMenuItem",
  componentId: "sc-xjrtor-1"
})(["float:none;list-style:none;", " ", " ", " ", ";"], props => props.itemWidth ? "width: ".concat(props.itemWidth, "px;") : '', props => props.noRoundedCorners ? '' : "border-radius: ".concat(props.positionToLeft ? "".concat(borderRadius.default, " 0 0 0") : "0 ".concat(borderRadius.default, " 0 0"), ";"), props => props.isLast && "border-radius: 0 0 ".concat(borderRadius.default, " ").concat(borderRadius.default, ";"), props => !props.noHover && "&:hover {\n      background-color: ".concat(colours.NEUTRALS_7, ";\n    }\n\n    &:active {\n      background-color: ").concat(colours.PRIMARY_1, ";\n\n      span {\n        color: ").concat(colours.WHITE, ";\n      };\n    };\n  };"));
const SubMenuItemInner = exports.SubMenuItemInner = _styledComponents.default.div.withConfig({
  displayName: "SubMenustyle__SubMenuItemInner",
  componentId: "sc-xjrtor-2"
})(["position:relative;text-decoration:none;display:block;", ";span{color:", ";}", " ", ""], ITEM_PADDING, colours.PRIMARY_1, props => {
  if (props.showing) {
    return "\n        margin: 0;\n        opacity: 1;\n      ";
  }
  return "\n      margin: 0 20px 0 -20px;\n      opacity: 0;\n    ";
}, _ref => {
  let {
    customItemWidth
  } = _ref;
  return customItemWidth ? ' width: 270px' : ' width: 100%;';
});